<script lang="ts">
  import { Translations } from "../translations";
  import { fade } from 'svelte/transition';
  import { onMount } from "svelte";

  export let translations: Translations;
  export let errors: any = {};
  
  export let firstname: string = "";
  export let lastname: string = "";
  export let isPayrollManagedAccount: boolean = false;
  export let allowExistingAccount: boolean = false;
  export let useExistingAccount: boolean = false;
  export let email: string = "";
  export let password: string = "";

  let passwordControl: any;

  $: if (allowExistingAccount  && passwordControl) {
    let i18n = {
      "errorMessage": translations.get("Some error occurred"),
      "successLabel": translations.get("Success"),
      "revealPasswordText": translations.get("Show"),
      "hidePasswordText": translations.get("Hide")
    };
    
    passwordControl.i18n = i18n;
  }

  function handleEmailInput(event: any) {
    if (allowExistingAccount) {
      useExistingAccount = false;
      allowExistingAccount = false;

      errors = {};
    }
  }
</script>


<style lang="scss">
  .wk-padding-bottom {
    padding-bottom: 1rem;
  }
</style>


<div in:fade class="wk-grid">
  <wk-input label='{translations.get("Your e-mail address for registration")}' on:input={handleEmailInput} class="wk-column-6 wk-column-12-xs" type-class="wk-field-small">
    <input class="wk-field-input"
           autocomplete="username"
           type='text'
           placeholder='{translations.get("Please enter your email")}'
           name='Email'
           maxlength="320"
           required
           bind:value={email}/>
    {#if errors.Email}<span class="wk-field-error field-validation-error">{errors.Email}</span>{/if}
  </wk-input>
</div>

{#if allowExistingAccount}
  <div in:fade class="wk-grid wk-padding-bottom">
    <span>{translations.get("We have found that there is already a user account with this email address. Would you like to link the current user account with the existing one?")}</span>
  </div>
  <div in:fade class="wk-grid">
    <div class="wk-field wk-field-small">
      <div class="wk-field-body">
        <label class="wk-field-choice-label">
          <input class="wk-field-choice" id="invitation-form-input-use-credentials" type="checkbox" value="use-credentials" bind:checked={useExistingAccount}>
          <span class="wk-field-choice-text">{translations.get("Yes, I would like to use the existing account")}</span>
        </label>
      </div>
    </div>
  </div>
  {#if useExistingAccount}
    <div in:fade class="wk-grid">
      <wk-password-input label='{translations.get("Password")}' bind:this={passwordControl} class="wk-column-6 wk-column-12-xs" type-class="wk-field-small">
        <input class="wk-field-input"
              id="invitation-form-input-password"
              autocomplete="current-password"
              type='password'
              placeholder='{translations.get("Please enter your password")}'
              name='Password'
              required
              bind:value={password} />
        {#if errors.Password}<span class="wk-field-error field-validation-error">{errors.Password}</span>{/if}
      </wk-password-input>
    </div>
  {/if}
{:else}
  <div in:fade class="wk-grid wk-padding-bottom">
    <span>{translations.get("Please also enter your name.")}</span>
  </div>
  <div in:fade class="wk-grid">
    <wk-input label='{translations.get("Firstname")}' class="wk-column-6" type-class="wk-field-small">
      <input class="wk-field-input"
            autocomplete="given-name"
            type='text'
            placeholder='{translations.get("Please enter your first name")}'
            name='Firstname'
            maxlength="255"
            required
            readonly={isPayrollManagedAccount}
            bind:value={firstname}/>
      {#if errors.Firstname}<span class="wk-field-error field-validation-error">{errors.Firstname}</span>{/if}
    </wk-input>
    <wk-input label='{translations.get("Lastname")}' class="wk-column-6" type-class="wk-field-small">
      <input class="wk-field-input"
            autocomplete="family-name"
            type='text'
            placeholder='{translations.get("Please enter your family name")}'
            name='Lastname'
            maxlength="255"
            required
            readonly={isPayrollManagedAccount}
            bind:value={lastname}/>
      {#if errors.Lastname}<span class="wk-field-error field-validation-error">{errors.Lastname}</span>{/if}
    </wk-input>
  </div>
{/if}

